module.exports = __webpack_public_path__ + "static/media/WomenUnsign.f404670a.svg";